import React from 'react';
import type { NavLink, Service, BlogPost, FAQItem, ProductCategory } from './types';
import { PenTool, Search, MessageSquare, ShieldCheck, CloudCog, Car, Bot, Newspaper, ShoppingBasket, Infinity, RefreshCw, GraduationCap, Zap, BookOpen, HelpCircle, FileText, Rocket, Wind, TreePine, ImageIcon, Link as LinkIcon, Briefcase, Sparkles, MessageCircleQuestion, BarChart3, Gavel, Target, Megaphone, Home, Package, Users, Mail, ArrowUpRight, Rss } from 'lucide-react';

export const PRODUCT_CATEGORIES: ProductCategory[] = [
    {
        name: "Obsługa klienta",
        icon: <Bot className="w-5 h-5 text-text-secondary-light dark:text-text-secondary-dark" />,
        products: [
            {
                icon: <MessageSquare className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
                title: 'Whatsappowy Doradca 24/7',
                description: 'Odpisuje klientom na WhatsAppie o każdej porze. Przyjmuje zamówienia i odpowiada na pytania.',
                path: '/rozwiazania/agent-whatsapp-ai',
            },
            {
                icon: <ShieldCheck className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
                title: 'Błyskawiczne Reklamacje',
                description: 'Czyta reklamację, ogląda zdjęcia i pisze projekt odpowiedzi. Ty sprawdzasz i wysyłasz.',
                path: '/rozwiazania/smartclaim-ai',
            },
            {
                icon: <Gavel className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
                title: 'Analiza Decyzji Administracyjnych',
                description: 'Czyta decyzję z urzędu i wskazuje, gdzie są błędy i na co powołać się w odwołaniu.',
                path: '/rozwiazania/legal-cloud-ai',
            },
            {
                icon: <Zap className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
                title: 'Mini-Chatbot FAQ',
                description: 'Okienko na Twojej stronie, które odpowiada na najczęstsze pytania klientów.',
                path: '/rozwiazania/zapytaj-chata-ai',
            },
        ]
    },
    {
        name: "Klienci i rynek",
        icon: <Target className="w-5 h-5 text-text-secondary-light dark:text-text-secondary-dark" />,
        products: [
            {
                icon: <Search className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
                title: 'Znajdź Klienta Pro',
                description: 'Szuka firm, które mogą być Twoimi klientami, i zbiera do nich kontakty.',
                path: '/rozwiazania/biznesfinder-ai',
            },
            {
                icon: <Car className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
                title: 'Łowca Okazji Auto',
                description: 'Pilnuje ogłoszeń motoryzacyjnych i daje znać, gdy pojawi się okazja.',
                path: '/rozwiazania/carhunter-ai',
            },
            {
                icon: <Rocket className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
                title: 'Gdzie Jest Twój Rozmiar?',
                description: 'Sprawdza w sklepach, gdzie są buty w Twoim rozmiarze i po jakiej cenie.',
                path: '/rozwiazania/sizehunter-ai',
            },
            {
                icon: <Newspaper className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
                title: 'Trend-Radar',
                description: 'Przegląda serwisy i podpowiada tematy, o których zaraz zrobi się głośno.',
                path: '/rozwiazania/newshunter-ai',
            }
        ]
    },
    {
        name: "Treści i marketing",
        icon: <Megaphone className="w-5 h-5 text-text-secondary-light dark:text-text-secondary-dark" />,
        products: [
            {
                icon: <Bot className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
                title: 'Fabryka Postów',
                description: 'Planuje posty, pisze je i publikuje w mediach społecznościowych.',
                path: '/rozwiazania/contentflow-ai',
            },
            {
                icon: <ImageIcon className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
                title: 'Auto-Grafik & Wideo',
                description: 'Robi grafiki i krótkie filmy do postów, wszystkie w jednym stylu.',
                path: '/rozwiazania/visual-generator-ai',
            },
            {
                icon: <ShoppingBasket className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
                title: 'Amazon Turbo Listing',
                description: 'Przykład z życia: system, który pilnował opisów, cen i stanów magazynowych na Amazonie.',
                path: '/rozwiazania/amazon-lister-ai',
            }
        ]
    },
    {
        name: "Finanse i połączenia",
        icon: <LinkIcon className="w-5 h-5 text-text-secondary-light dark:text-text-secondary-dark" />,
        products: [
            {
                icon: <RefreshCw className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
                title: 'Synchronizacja PayPal',
                description: 'Przepisuje wpłaty z PayPala do księgowości. Koniec z ręcznym uzgadnianiem.',
                path: '/rozwiazania/paypal-sync-ai',
            },
            {
                icon: <LinkIcon className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
                title: 'Integracje Allegro & Shopify',
                description: 'Łączy Twój sklep z Allegro i Shopify, żeby dane przechodziły same.',
                path: '/rozwiazania/integracje',
            }
        ]
    },
    {
        name: "Core & Specjalne Projekty",
        icon: <Sparkles className="w-5 h-5 text-text-secondary-light dark:text-text-secondary-dark" />,
        products: [
            {
                icon: <Infinity className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
                title: 'System Dochodu Pasywnego',
                description: 'Szuka tematów, na które jest popyt, i pomaga zrobić z nich produkt do sprzedaży.',
                path: '/rozwiazania/perpetuum-ai',
            },
            {
                icon: <Wind className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
                title: 'Analizator Energii OZE',
                description: 'Sprawdza, czy działka nadaje się pod panele słoneczne albo wiatrak.',
                path: '/rozwiazania/gridmaster-ai',
            },
            {
                icon: <Sparkles className="w-8 h-8 text-primary-light dark:text-primary-dark" />,
                title: 'Gra Zielonej Energii',
                description: 'Gra edukacyjna o zielonej energii dla leśnictwa.',
                path: '/rozwiazania/windsynergy-ai',
            },
        ]
    },
    {
        name: "Edukacja & Społeczność",
        icon: <GraduationCap className="w-5 h-5 text-text-secondary-light dark:text-text-secondary-dark" />,
        products: [
            { icon: <GraduationCap className="w-8 h-8 text-primary-light dark:text-primary-dark" />, title: 'Warsztat AI dla Kancelarii', description: 'Intensywny 3-godzinny warsztat, który odmieni Twoją kancelarię.', path: '/edukacja/szkolenie-ai-kancelarie' },
            { icon: <BarChart3 className="w-8 h-8 text-primary-light dark:text-primary-dark" />, title: 'Kalkulator ROI', description: 'Oblicz zwrot z inwestycji w AI dla Twojej kancelarii.', path: '/edukacja/kalkulator-roi-ai' },
            { icon: <HelpCircle className="w-8 h-8 text-primary-light dark:text-primary-dark" />, title: 'Quiz Automatyzacyjny', description: 'Sprawdź w 2 minuty, ile możesz zaoszczędzić dzięki automatyzacji.', path: '/edukacja/ai-quiz' },
            { icon: <MessageCircleQuestion className="w-8 h-8 text-primary-light dark:text-primary-dark" />, title: 'Najczęstsze Pytania', description: 'Najczęściej zadawane pytania.', path: '/spolecznosc/faq' },
        ]
    }
];

export const ALL_PRODUCTS: Service[] = PRODUCT_CATEGORIES.flatMap(category => category.products);

export const FLAGSHIP_PRODUCTS: Service[] = [
    ALL_PRODUCTS.find(p => p.path === '/rozwiazania/agent-whatsapp-ai')!,
    ALL_PRODUCTS.find(p => p.path === '/rozwiazania/biznesfinder-ai')!,
    ALL_PRODUCTS.find(p => p.path === '/rozwiazania/legal-cloud-ai')!,
    ALL_PRODUCTS.find(p => p.path === '/rozwiazania/smartclaim-ai')!,
];

const produktySubLinks: NavLink[] = PRODUCT_CATEGORIES.map(category => ({
    name: category.name,
    path: '#',
    icon: category.icon,
    subLinks: category.products.map(product => {
        const smallIcon = React.isValidElement(product.icon) 
            ? React.cloneElement(product.icon as React.ReactElement<any>, { className: 'w-5 h-5 text-primary-light dark:text-primary-dark' }) 
            : product.icon;

        return {
            name: product.title,
            path: product.path,
            icon: smallIcon,
        };
    })
}));

export const NAV_LINKS: NavLink[] = [
  { name: 'Strona Główna', path: '/', icon: <Home className="w-4 h-4" /> },
  { 
    name: 'Produkty', 
    path: '/produkty', 
    icon: <Package className="w-4 h-4" />,
    subLinks: produktySubLinks
  },
  { name: 'Prompty', path: '/prompty', icon: <Sparkles className="w-4 h-4" /> },
  { name: 'Case Studies', path: '/case-studies', icon: <Briefcase className="w-4 h-4" /> },
  { name: 'FAQ', path: '/spolecznosc/faq', icon: <HelpCircle className="w-4 h-4" /> },
  { 
    name: 'Współpraca', 
    path: 'https://bartoszgaca.pl/?utm_source=biznesbezklikania&utm_medium=menu&utm_campaign=bbk%E2%86%92bg', 
    icon: <ArrowUpRight className="w-4 h-4" />,
    external: true 
  },
];

export const BLOG_POSTS: BlogPost[] = [
  {
    id: 1,
    category: 'Trendy 2025',
    title: 'AI w 2025: 7 trendów, które zmienią Twój biznes',
    excerpt: 'Które z tych narzędzi naprawdę zdejmują robotę z głowy, a które tylko ładnie brzmią. Bez owijania.',
    author: 'Marcin Kowalski',
    authorInitials: 'MK',
  },
  {
    id: 2,
    category: 'Obsługa Klienta',
    title: 'Jak Agent AI WhatsApp zwiększył sprzedaż o 450%',
    excerpt: 'Prawdziwa historia TechShop.pl, który dzięki automatyzacji obsługi klienta przez WhatsApp osiągnął niewiarygodne wyniki.',
    author: 'Bartosz Gaca',
    authorInitials: 'BG',
  },
  {
    id: 3,
    category: 'Lead Generation',
    title: '5000 leadów B2B za 1 zł - przewodnik krok po kroku',
    excerpt: 'Kompletny poradnik, jak wykorzystać AI do automatycznego pozyskiwania leadów B2B z publicznych źródeł.',
    author: 'Michał Nowak',
    authorInitials: 'MN',
  },
  {
    id: 4,
    category: 'Automatyzacja',
    title: 'Koniec z niezrozumiałymi pismami z urzędu',
    excerpt: 'Zobacz, jak AI analizuje pisma urzędowe w 3 minuty i generuje gotowe odpowiedzi. Przykłady z ZUS, US i sądów.',
    author: 'Anna Wiśniewska',
    authorInitials: 'AW',
  },
];

export const FAQS: FAQItem[] = [
    {
        question: "Czym dokładnie zajmuje się BiznesBezKlikania.pl?",
        answer: "Zdejmujemy z głowy czynności, które robisz ręcznie w kółko. Szukanie klientów, odpisywanie na te same pytania, czytanie pism z urzędu. Zaczynamy od jednej takiej czynności, nie od przebudowy całej firmy."
    },
    {
        question: "Jak wygląda proces wdrożenia?",
        answer: "Cztery kroki. Najpierw rozmowa, na której mówisz, co Cię najbardziej męczy. Potem ustawiamy narzędzie pod Ciebie. Potem testujemy i pokazujemy, jak z tego korzystać. Na końcu włączamy. Termin podajemy po rozmowie, bo zależy od tego, co dokładnie automatyzujemy."
    },
    {
        question: "Czy mogę przetestować rozwiązania przed zakupem?",
        answer: "Tak. Znajdź Klienta Pro daje 10 pierwszych kontaktów za darmo, Doradca na WhatsAppie działa 7 dni na próbę, a pierwsze pismo analizujemy bez opłat. Możemy też po prostu pokazać, jak to działa, na żywo."
    },
    {
        question: "Jak dbacie o bezpieczeństwo danych?",
        answer: "Twoje dane są szyfrowane i nie trafiają do nikogo poza nami. Pracujemy zgodnie z RODO. Jeśli chcesz wiedzieć dokładnie, gdzie i jak długo są przechowywane, pytaj wprost, odpiszemy konkretem."
    }
];